import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectVersionsConfigProviderEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-project-versions-config-provider" */ './ProjectVersionsConfigProvider'
		).then((module) => module.ProjectVersionsConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
